module.exports = __webpack_public_path__ + "img/logo.f2d9d5ef.svg";